import React from 'react'
import { IconPropsType } from '../types'

const CameroonIcon = ({ className }: IconPropsType) => {
  return (
    <svg
      className={className}
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_15424_25134)'>
        <path
          d='M25.5992 0H-1.60078C-3.36809 0 -4.80078 1.43269 -4.80078 3.2V20.8C-4.80078 22.5673 -3.36809 24 -1.60078 24H25.5992C27.3665 24 28.7992 22.5673 28.7992 20.8V3.2C28.7992 1.43269 27.3665 0 25.5992 0Z'
          fill='#F93939'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12.0001 14L9.64811 15.2368L10.0961 12.6176L8.19531 10.7616L10.8241 10.3824L12.0001 8L13.1761 10.384L15.8049 10.7632L13.9009 12.6192L14.3489 15.2368'
          fill='#FFDA2C'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M-4.80078 0H6.39922V24H-4.80078V0Z'
          fill='#249F58'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M17.5996 0H28.7996V24H17.5996V0Z'
          fill='#FFDA2C'
        />
      </g>
      <rect x='0.5' y='0.5' width='23' height='23' rx='11.5' stroke='white' />
      <defs>
        <clipPath id='clip0_15424_25134'>
          <rect width='24' height='24' rx='12' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default CameroonIcon
